import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'

import { Typography, Card, WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)

const Faq: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="FAQ" />
      <div className={classes.root}>
        <div className="l-pageHeader">
          <Typography variant="h1">FAQ&apos;s</Typography>
        </div>
        <Card
          header={
            <Typography variant="h3" className="l-lockedContent__title">
              Select an question or select a topic
            </Typography>
          }
        />
      </div>
    </>
  )
}

export default Faq
